export const maxScope = 'read,activity:read_all,activity:write'
